import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f02af20a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wp1200 flex" }
const _hoisted_2 = { class: "crest" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "crestText" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { id: "topBar" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_search" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "topMenu" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "46",
  height: "46",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.0"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M14 7a2 2 0 1 1-4 0a2 2 0 0 1 4 0Z" }),
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      d: "M18 10s-3.537 1.5-6 1.5S6 10 6 10m6 2v1.452m0 0a3 3 0 0 0 .476 1.623L15 19m-3-5.548a3 3 0 0 1-.476 1.623L9 19"
    })
  ])
], -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_AvatarCustom = _resolveComponent("AvatarCustom")!
  const _component_Accessibility = _resolveComponent("Accessibility")!
  const _component_ChangeLanguage = _resolveComponent("ChangeLanguage")!
  const _component_Navigation = _resolveComponent("Navigation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAccessibilityActive === false)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "responsiveMenuButton",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("header", {
      class: _normalizeClass(["header", { active: _ctx.showMenu }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pushRoute('Home'))),
          class: "flex logo"
        }, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.storageUrl + '/logo.png',
              alt: 'Grb ' + _ctx.$t('city.app_name')
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("img", {
              class: "city",
              src: _ctx.storageUrl + '/' + _ctx.$i18n.locale + '/cityName.svg',
              alt: _ctx.$t('city.app_name')
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Notifications),
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pushRoute('MySuperCity'))),
                class: "user web"
              }, [
                _createVNode(_component_AvatarCustom, {
                  src: _ctx.$store.getters['user/userImage'],
                  class: "medium responsive"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pushRoute('Search'))),
            class: "search"
          }, _hoisted_8),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Accessibility, {
              ref: "accessibilityMenu",
              class: "accesibilityMenu",
              tabindex: "0",
              onKeyup: _withKeys(_ctx.openAccesibilityMenu, ["enter"]),
              locale: _ctx.$i18n.locale
            }, {
              trigger: _withCtx(() => [
                _createElementVNode("button", {
                  "data-event": "accessibility",
                  class: "sxaBtn",
                  tabindex: "-1",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isAccessibilityActive = true))
                }, _hoisted_11)
              ]),
              _: 1
            }, 8, ["onKeyup", "locale"]),
            _createElementVNode("span", {
              tabindex: "0",
              class: "menu",
              onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["enter"])),
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
            }, null, 32),
            _createVNode(_component_ChangeLanguage)
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_Navigation, {
      class: _normalizeClass({ active: _ctx.showMenu }),
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showMenu = false))
    }, null, 8, ["class"])
  ], 64))
}